import { createListenerMiddleware } from '@reduxjs/toolkit';

export const rankingListenerMiddleware = createListenerMiddleware();
export const sharedShippingLogMiddleware = createListenerMiddleware();
